<template>
  <v-card class="text-xs-center pb-2 mt-0" flat>    
    <v-flex d-flex>
      <!-- TITLE -->
      <v-flex class="text-xs-right" pt-4>
        <h3>Mostrar Vehículos en el mapa por:</h3>
      </v-flex>
      <!-- CLOSE BUTTON -->
      <v-flex style="width: 50px;" class="text-xs-right" mt-1>
        <v-btn
          color="error"
          small
          depressed
          fab
          @click="closeHomeFilters"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <v-flex
      v-if="showAgenciesTree || showZones"
      class="tuning-container"
      mx-4
      mb-1
      mt-3
      pa-1
    >
      <v-expansion-panel v-model="openExpan" expand>
        <v-expansion-panel-content>
          <v-flex class="text-xs-center" slot="header">
            <h2>Filtros Complementarios</h2>
          </v-flex>
          <v-card color="grey darken-4">
            <v-card-text>
              <!-- FIRST LINE FILTERS -->
              <v-flex d-flex>
                <!-- IGNITION TYPE -->
                <v-flex xs6 style="margin-top: 12px;" pr-1>
                  <v-autocomplete
                    v-model="ignitionIn"
                    :items="ignitionItems"
                    clearable
                    label="Ignición"
                    color="white"
                    item-text="name"
                    item-value="value"
                    box
                  />
                </v-flex>
                <!-- VEHICLE STATE -->
                <v-flex xs6 pl-1>
                  <v-autocomplete
                    v-model="stateVehicleSelectedIn"
                    :items="vehicleStates"
                    chips
                    clearable
                    color="white"
                    label="Estado Vehículo"
                    item-text="name"
                    item-value="value"
                    box
                    multiple
                    return-object
                    aria-autocomplete=""  
                  >
                    <template v-slot:selection="{ index }">
                      <!-- :selected="data.selected" -->
                      <v-chip
                        v-if="index === 0"
                        small
                      >
                        <!-- <v-avatar :color="data.item.avatar" size="21" /> -->
                        {{
                          `
                            ${stateVehicleSelectedIn.length} 
                              ${stateVehicleSelectedIn.length > 1
                                ? 'Estados'
                                : 'Estado'}
                          `
                        }}
                      </v-chip>
                    </template>

                    <template v-slot:item="data">
                      <v-flex
                        d-inline-flex
                        align-center
                        ma-0
                        pa-0
                      >
                        <v-icon v-if="checkItem(data.item.value)">done</v-icon>
                        <v-list-tile-avatar :color="data.item.avatar" size="21" />
                        <v-list-tile-content>
                          <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                          <v-list-tile-sub-title v-html="data.item.description"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-flex>
                    </template>
                  </v-autocomplete>
                  
                </v-flex>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-divider v-if="showAgenciesTree || showZones" class="mx-3 my-2"></v-divider>
    <v-flex d-flex px-4 pt-1>
      <!-- AGENCIES BUTTON -->
      <v-flex pr-1>
        <v-btn
          block
          :disabled="showAgenciesTree"
          @click="agenciesSelected"
        >
          <v-icon left>business</v-icon>
          Agencias
        </v-btn>
      </v-flex>
      <!-- ZONES BUTTON -->
      <v-flex pl-1>
        <v-btn
          block
          :disabled="showZones"
          @click="zonesSelected"
        >
          <v-icon left>layers</v-icon>
          Zonas
        </v-btn>
      </v-flex>
    </v-flex>
    
    <!-- AGENCIES TREE-->
    <v-flex v-if="showAgenciesTree">
      <!-- <v-divider class="mx-3" ></v-divider> -->
      <agencies-tree
        class="text-xs-left"
        :from-section="fromSection"
        :mapref="mapref"
      />
    </v-flex>

    <!-- ZONES OPTIONS -->
    <v-flex v-if="showZones" px-2>
      <!-- <v-divider class="mx-3" ></v-divider> -->
      <vehicles-filter :mapref="mapref"/>
    </v-flex>

    
  </v-card>    
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import AgenciesTree from './AgenciesTree.vue'
  import VehiclesFilter from './VehiclesFilter.vue'
  import {vehicleStates} from '../utils/vehicleStates'

  export default {
    name: 'home-filter',
    components: {
      AgenciesTree,
      VehiclesFilter
    },
    props: {
      mapref: {
        type: Object
      }
    },
    data() {
      return {
        openExpan: [ true ],
        // stateVehicleSelected: [],
        vehicleStates,
        // ignition: null,
        ignitionItems: [
          {value: 'ON', name: 'Encendido'},
          {value: 'OFF', name: 'Apagado'}
        ],
        fromSection: 'filter',
        showZones: false,
        showAgenciesTree: false,
        selectedItems: []
      }
    },
    computed: {
      ...mapGetters([
        'agencySelected',
        'filterType',
        'ignition',
        'stateVehicleSelected'
      ]),
      ignitionIn: {
        get() {
          return this.ignition
        },
        set(value) {
          this.setIgnitionFilter(value)
        }
      },
      stateVehicleSelectedIn: {
        get() {
          return this.stateVehicleSelected
        },
        set(value) {
          this.setStateVehicleSelectedFilter(value)
        }
      }
    },
    methods: {
      ...mapActions([
        'setIgnitionFilter',
        'setStateVehicleSelectedFilter',
        'displayFiltersHome',
        'addFilterTypeHome'
      ]),
      zonesSelected() {
        this.fromSection = 'zones'
        this.showZones = true
        this.showAgenciesTree = false
      },
      agenciesSelected() {
        this.fromSection = 'filter'
        this.showAgenciesTree = true
        this.showZones = false
      },
      closeHomeFilters() {
        this.addFilterTypeHome(this.filterType)
        this.displayFiltersHome(false)
      },
      checkItem(item) {
        let result = false
        for (let index = 0; index < this.stateVehicleSelected.length; index++) {
          const element = this.stateVehicleSelected[index]
          result = element.value === item
          if (result) break
        }
        return result
      }
    }
  }
</script>

<style lang="stylus" scoped>
h4
  font-size 14px
  font-weight 400

.tuning-container
  background-color #212121
  border-radius 2px

.selected-item {
  margin-left: -20px;
  padding-left: 20px;
  border-left: 2px solid #1E88E5;
}

</style>


// WEBPACK FOOTER //
// src/components/HomeFilter.vue